import React, { InputHTMLAttributes } from "react";
import Container from "./styled";

const Input: React.FC<InputHTMLAttributes<HTMLInputElement>> = ({
  type,
  placeholder,
  id,
  maxLength,
  value,
  onChange,
  onBlur,
}) => {
  return (
    <Container>
      <input
        type={type}
        id={id}
        value={value}
        onChange={onChange}
        maxLength={maxLength}
        onBlur={onBlur}
      />

      <label htmlFor={id} className={value ? "active" : ""}>
        {placeholder}
      </label>
    </Container>
  );
};

export default Input;
